module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av273-ee7f3ac3613138cdf192e188aa5d6b19.jpg";